import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  onOkay: () => void;
}

export function UnsavedChangesDialog({ open, onClose, onOkay }: Props) {
  return (
    <DialogConfirmation
      id="unsaved-changes"
      open={open}
      title={translate('Unsaved Changes')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton key="yes" appearance="primary" onClick={onOkay}>
          {translate('Yes')}
        </UIButton>,
        <UIButton key="no" onClick={onClose}>
          {translate('No')}
        </UIButton>,
      ]}
    >
      {translate('Are you sure you want to leave without saving this quiz?')}
    </DialogConfirmation>
  );
}
